/**
 * Cache configuration constants for R2F data operations
 */
export const CACHE_TIMES = {
  /** Cache time for R2F threshold data - 5 minutes */
  STALE_TIME: 5 * 60 * 1000,
  /** Cache time for R2F threshold data - 10 minutes */
  CACHE_TIME: 10 * 60 * 1000,
} as const;

/**
 * Cache keys for React Query cache
 */
export const CACHE_KEYS = {
  SHIPMENT_UPDATES: 'shipment-updates',
} as const;

/**
 * Default warehouse IDs for warehouse selection
 * These should be replaced with actual warehouse IDs from your backend
 */
export const DEFAULT_WAREHOUSE_IDS = [
  'SNE1',
  'BWI2', 
  'BWI1'
] as const;